<template>

    <div v-show="show" id="builder-tooltip" :style="styles">
        <span v-if="anchor && formattedLink().length" @click="openLink" :title="formattedLink()">
            <i class="fas fa-external-link-alt mr-5"></i>
            <span>{{ formattedLink() | truncate(30) }}</span>
        </span>
        <span v-else @click="openLink">Missing Link</span>
        <span class="edit" @click="editLink">
            <i class="fas fa-pencil"></i>
        </span>
    </div>

</template>

<style scoped lang="scss">

    #builder-tooltip {
        align-items: center;
        background: $color-text;
        border-radius: 5px;
        display: flex;
        left: 0;
        padding: 10px;
        position: fixed;
        top: 0;
        transition: none;
        width: auto;
        z-index: 100;
        > span {
            @include font-semibold(11px);
            appearance: none;
            background: none;
            border: none;
            color: rgba(255,255,255,0.8);
            cursor: pointer;
            transition: color .3s;
            user-select: none;
            &:hover {
                color: #fff;
            }
        }
        .edit {
            cursor: pointer;
            margin-left: 10px;
            opacity: 0.8;
            transition: opacity .3s;
            &:hover {
                opacity: 1;
            }
        }
        &::after {
            top: -6px;
            content: "";
            border-bottom: 6px solid $color-text;
            border-left: 6px solid transparent;
            border-right: 6px solid transparent;
            display: block;
            left: 50%;
            margin-left: -6px;
            position: absolute;
        }
    }

</style>

<script>

export default {

    mounted() {
        // Add listeners.
        window.addEventListener('mouseover', this.onMouseOver);
        window.addEventListener('mousedown', this.onMouseDown);
    },

    beforeDestroy() {
        // Remove listeners.
        window.removeEventListener('mouseover', this.onMouseOver);
        window.removeEventListener('mousedown', this.onMouseDown);
    },

    data() {
        return {
            show: false,
            styles: {},
            target: null,
            anchor: null,
        }
    },

    methods: {

        shouldShow() {
            let id = this.target.attributes.id?.value;
            if ((this.target.tagName === 'A' || this.target.parentElement?.closest('A')) && this.target.parentElement?.closest('.block')) {
                return true;
            } else if (id === 'builder-tooltip' || this.target.parentElement?.closest('#builder-tooltip')) {
                return true;
            }
            return false;
        },

        onMouseOver(e) {
            this.target = e.target;
            if (this.shouldShow()) {
                this.show = true;
                if (this.target.tagName === 'A' || this.target.parentElement?.closest('A')) {
                    if (this.target.tagName !== 'A') {
                        this.target = this.target.parentElement?.closest('A');
                    }
                    this.anchor = this.target;
                    this.$nextTick(() => {
                        let rectTooltip = document.getElementById('builder-tooltip').getBoundingClientRect();
                        let rectSel = this.target.getBoundingClientRect();
                        let x = rectSel.left + (rectSel.width / 2) - (rectTooltip.width / 2);
                        let y = (rectSel.bottom + 10);
                        this.styles = { left: x + 'px', top: y + 'px' };
                    });
                }
            } else if (this.show === true) {
                setTimeout(this.dismiss, 1000);
            }
        },

        onMouseDown(e) {
            if (!this.shouldShow()) {
                this.show = false;
            }
        },

        editLink() {
            this.$store.commit('builder/setSelectedModalParams', {
                link: this.formattedLink(),
                target: this.anchor,
            });
            this.$store.commit('builder/setSelectedModal', 'link');
            this.show = false;
        },

        openLink() {
            window.open(this.anchor.attributes['href'].value, '_blank');
            this.show = false;
        },

        formattedLink() {
            let val = this.anchor.attributes['href'].value;
            return decodeURIComponent(val.replace(/\+/g, ' '));
        },

        dismiss() {
            this.show = this.shouldShow();
        },

    }

}

</script>